import React, { useRef } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { Filter, Datagrid, useTranslate, FunctionField, List, TextInput, NumberField, Pagination, ReferenceField, TextField, useListContext, usePermissions, useLocaleState, ReferenceInput, AutocompleteInput } from 'react-admin'
import { autocompleteInputCommonStyle, datagridCommonStyle, listCommonStyle, searchInputCommonStyle } from '../../../themes/commonStyles'
import { LIST_TYPE_TABLE } from '../../../ui/button/ListTypeButton';
import { useTheme, useMediaQuery, Box, Typography,Slide,Dialog,DialogContent,Button } from '@mui/material';
import { isROAdmin, isSuperAdmin } from '../../../helper/resourceHelper'
import { AddBtnWithOptionalMenu } from '../../../ui/button/AddBtn';
import SearchInputLabelComponent from '../../../ui/inputs/SearchInputLabelComponent';
import EditButton from '../../../ui/button/EditButton';
import SmsCreditPlanActivateButton from '../../../ui/button/SmsCreditPlanActivateButton';
import SmsCreditPlanArchiveButton from '../../../ui/button/SmsCreditPlanArchiveButton';
import CustomChip from '../../../ui/CustomChip';
import ShowButton from '../../../ui/button/ShowButton';
import LoadingDialog from '../../../ui/dialog/LoadingDialog';
import MobileGrid from './MobileGrid';






const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FiltersDialog = ({ open, setOpen }) => {

    const theme = useTheme();
    const contentBg = theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.background.default;
    const translate = useTranslate();
    const dialogRef = useRef(null);
    const {
        displayedFilters,
        filterValues,
        setFilters,
        hideFilter
    } = useListContext();

    const form = useForm({
        defaultValues: filterValues,
    });


    const onSubmit = (values) => {
        if (Object.keys(values).length > 0) {
            setFilters(values, undefined, false);
        } else {
            hideFilter("main");
        }

        setTimeout(() => {
            setOpen(false)
        }, 500);
    };

    const resetFilter = () => {
        setFilters({}, [], false);
        setTimeout(() => {
            setOpen(false)
        }, 500);
    };


    const handleClose = () => setOpen(false);




    const handleDrag = (event) => {
        const dialogElement = dialogRef.current;
        if (!dialogElement) return;

        // Detect touch or mouse events
        const startY = event.type === 'mousedown'
            ? event.clientY
            : event.touches[0].clientY;

        const onMove = (moveEvent) => {
            const currentY = moveEvent.type === 'mousemove'
                ? moveEvent.clientY
                : moveEvent.touches[0].clientY;

            const deltaY = currentY - startY;

            if (deltaY > 150) {
                // Close the dialog if dragged down more than 150px
                handleClose();
            } else {
                // Temporarily move the dialog down
                dialogElement.style.transform = `translateY(${Math.min(deltaY, 150)}px)`;
            }
        };

        const onEnd = () => {
            // Reset dialog position and remove listeners
            dialogElement.style.transform = '';
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onEnd);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onEnd);
        };

        // Add listeners for dragging and release
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);
        window.addEventListener('touchmove', onMove);
        window.addEventListener('touchend', onEnd);
    };

    return (
        <Dialog
            ref={dialogRef}
            open={open}
            TransitionComponent={Transition}
            onClose={() => { }}
            fullScreen
            PaperProps={{
                style: { boxShadow: 'none' }, // Optional: Remove shadow around the dialog
            }}
            slotProps={{
                backdrop: { style: { backgroundColor: 'transparent' } }
            }}
            sx={{
                "& .MuiPaper-root": {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: "auto",
                    minHeight: "300px",
                    maxHeight: "400px",
                    margin: "0px",
                    padding: "0px",
                    border: 1,
                    borderTopColor: theme.palette.text.disabled,
                    borderWidth: "1px",
                    borderRadius: "12px 12px 0px 0px"
                }
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    height: "15px",
                    margin: "0px",
                    padding: "10px 0px 10px 0px",
                    borderRadius: "0px",
                    backgroundColor: "none",
                    opacity: 0.45,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
                onMouseDown={handleDrag} // Handle mouse drag
                onTouchStart={handleDrag}

            >
                <Box
                    sx={{
                        width: "40px",
                        height: "4px",
                        margin: "1px",
                        borderRadius: "12px",
                        backgroundColor: theme.palette.text.secondary,
                        opacity: 0.45
                    }}


                >
                </Box>
            </Box>
            <DialogContent

                sx={{
                    width: "100%",
                    margin: "0px",
                    padding: "0px",
                    background: contentBg,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ padding: "0px 0px 0px 16px" }}>
                        <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "20px", lineHeight: "28px" }}>
                            {translate("resources.common.filter")}
                        </Typography>
                    </Box>
                </Box>

                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}
                        style={{
                            width: "100%",
                            height: "auto",
                        }}
                    >
                        <Box
                            sx={{
                                margin: "25px 0px 0px 0px",
                                padding: "16px 16px 30px 16px",
                                background: contentBg,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >

                            <Box component="span" mb="38px" sx={{ width: "100%" }}>
                                <TextInput
                                    id="outlined-basic-size-small"
                                    label={<SearchInputLabelComponent />}
                                    source="q"
                                    alwaysOn
                                    sx={searchInputCommonStyle({ theme, width: "100%" })}
                                />


                            </Box>

                            <Box component="span" mb="10px" sx={{ width: "100%" }}>
                                {isSuperAdmin() && <ReferenceInput source="root_organization_id" reference="root_organizations" alwaysOn >
                                    <AutocompleteInput
                                        id="outlined-basic-size-small"
                                        optionText="name"
                                        matchSuggestion={() => true} label="resources.sms_credit_plans.fields.root_organization"
                                        sx={autocompleteInputCommonStyle({ theme, width: "100%" })}
                                    />
                                </ReferenceInput>}
                            </Box>

                            <Box component="span" mt="16px" sx={{ width: "100%" }}>
                                <Button variant="contained" color="primary" type="submit" sx={{ width: "100%" }}>
                                    {translate('resources.common.apply_filters')}
                                </Button>
                            </Box>
                            <Box component="span" mb="8px" sx={{ width: "100%" }}>
                                <Button variant="text" sx={{ width: "100%" }} onClick={resetFilter} >
                                    {translate('resources.common.reset_filters')}
                                </Button>
                            </Box>

                        </Box>
                    </form>
                </FormProvider>
            </DialogContent>


        </Dialog>
    )
}

const FiltersIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-filter">
            <path stroke="none" d="M0 0h16v16H0z" fill="none" strokeWidth="0.6666666666666666" />
            <path d="M2.667 2.667h10.667v1.448a1.333 1.333 0 0 1 -0.391 0.943L10 8v4.667l-4 1.333v-5.667L3.013 5.048A1.333 1.333 0 0 1 2.667 4.151z" />
        </svg>
    )
}


const FiltersBtn = ({ label, color }) => {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <Button sx={{ color: color }}
                onClick={(e) => { e.preventDefault(); setOpen(!open) }}
            >
                <FiltersIcon color={color} />&nbsp;{label}
            </Button>
            <FiltersDialog open={open} setOpen={setOpen} />
        </div>



    )
}








const SmsCreditPlanListActions = ({
    isMobile
}) => {
    const { resource } = useListContext();
    const theme = useTheme();
    const translate = useTranslate();
    const addBtnMenuItems = []


    if (isSuperAdmin() || isROAdmin()) {
        addBtnMenuItems.push({
            label: translate('resources.sms_credit_plans.add_new_device_sub_plans'),
            path: `/${resource}/create`
        })
    }


    if (!isMobile) {
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "row"

            }}>

                <AddBtnWithOptionalMenu menuItems={addBtnMenuItems} isMobile={isMobile} />
            </Box>
        )
    }


    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "0px",
            margin: "0px",
            width: "100%",
        }}>
            <FiltersBtn
                color={theme.palette.text.secondary}
                label={translate("resources.common.filter")}
            />

            <AddBtnWithOptionalMenu menuItems={addBtnMenuItems} isMobile={isMobile} />
        </Box>
    )


}




const SmsCreditPlanListPagination = ({ }) => {
    const theme = useTheme()


    return (<Pagination sx={{
        '& .MuiToolbar-root': {
            borderTopRightRadius: "0px",
            borderTopLeftRadius: "0px",
            borderBottomRightRadius: "12px",
            borderBottomLeftRadius: "12px",
            marginTop: "0px",

        }

    }} rowsPerPageOptions={[10, 25, 50, 100, 500]} />)
};

const LoadingPopUp = ({ }) => {
    const { isPending, isFetching, isLoading } = useListContext();
    return (
        <LoadingDialog
            isPending={isPending}
            isFetching={isFetching}
            isLoading={isLoading}
        />
    )

};

export const SmsCreditPlanList = props => {
    const [locale, setLocale] = useLocaleState();
    const isLargeOrLess = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const theme = useTheme();
    const translate = useTranslate();

    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                {translate('resources.sms_credit_plans.name', { smart_count: 2 })}
            </Typography>

            <List
                actions={<SmsCreditPlanListActions isMobile={isLargeOrLess}/>}
                filter={{ includes: 'plan', language: locale ? locale : "en" }}
                filters={!isLargeOrLess ?
                    <Filter  {...props}>
                        <TextInput
                            id="outlined-basic-size-small"
                            label={<SearchInputLabelComponent />}
                            source="q"
                            alwaysOn
                            sx={searchInputCommonStyle({ theme })}
                        />
                         {isSuperAdmin() &&  <ReferenceInput source="root_organization_id" reference="root_organizations" alwaysOn >
                            <AutocompleteInput
                                id="outlined-basic-size-small"
                                disablePortal
                                optionText="name"
                                matchSuggestion={() => true} label="resources.sms_credit_plans.fields.root_organization"
                                sx={autocompleteInputCommonStyle({ theme })}
                            />
                        </ReferenceInput>}
                    </Filter>:null
                
            }
                sx={listCommonStyle({ isLargeOrLess: isLargeOrLess, listFormat: LIST_TYPE_TABLE, theme })}
                perPage={25}
                pagination={false}
            >
                 {(isLargeOrLess) ? (
                    <MobileGrid />
                ) : (
                    <Datagrid
                    bulkActionButtons={false}
                    size='small'
                    sx={datagridCommonStyle({ theme })}
                >
                    <TextField source="title" />
                    <NumberField source="sms_quantity" />
                    <NumberField source="amount" />
                    <NumberField source="tax_percent" />
                    <TextField source="currency" />
                    <FunctionField
                        label={translate('resources.sms_credit_plans.fields.viewership_rule')}
                        render={record => record.viewership_rule ? <CustomChip label={translate(`resources.sms_credit_plans.viewership_rule.${record.viewership_rule}`)} value={record.viewership_rule} /> : null}
                        sortable={false}
                    />

                    <ReferenceField source="root_organization_id" reference="root_organizations" allowEmpty>
                        <FunctionField
                            render={record => record.name ? record.name.toUpperCase() : record.id}
                            sortable={false}
                        />
                    </ReferenceField>


                    <ReferenceField source="created_by" reference="users" allowEmpty>
                        <FunctionField
                            render={record => record.first_name && record.last_name ? record.first_name.toUpperCase() + ' ' + record.last_name.toUpperCase() : record.email}
                            sortable={false}
                        />
                    </ReferenceField>

                    <FunctionField
                        label={translate('resources.common.actions', { smart_count: 1 })}
                        render={record =>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                }}>
                                <EditButton disabled={!isSuperAdmin() && (!record || record.viewership_rule !== "private")} record={record} />
                                {isSuperAdmin() &&
                                    <SmsCreditPlanActivateButton disabled={!record || record.viewership_rule !== "private"} record={record} />}
                                {isSuperAdmin() &&
                                    <SmsCreditPlanArchiveButton disabled={!record || record.viewership_rule === "archived"} record={record} />}

                                <ShowButton disabled={false} record={record} />

                            </Box>
                        }
                    />



                </Datagrid>
                )}
                <SmsCreditPlanListPagination />
                <LoadingPopUp />
            </List>
        </>
    )

}


